import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

// Show an in-feed native ad after every N Calls in the home feed.
export const FEED_AD_INTERVAL = 5;

const AdsContext = createContext({ client: "", slots: { feed: "", receipt: "" }, enabled: false });
export const useAds = () => useContext(AdsContext);

let _loaded = false;
function injectScript(client) {
  if (_loaded || !client || typeof document === "undefined") return;
  if (document.getElementById("adsbygoogle-js")) { _loaded = true; return; }
  const s = document.createElement("script");
  s.id = "adsbygoogle-js";
  s.async = true;
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${client}`;
  s.crossOrigin = "anonymous";
  document.head.appendChild(s);
  _loaded = true;
}

export function AdsProvider({ children }) {
  const [cfg, setCfg] = useState({ client: "", slots: { feed: "", receipt: "" }, enabled: false });
  useEffect(() => {
    api.get("/config").then(({ data }) => {
      const ads = data.ads || {};
      const enabled = Boolean(ads.client && (ads.feed || ads.receipt));
      setCfg({ client: ads.client || "", slots: { feed: ads.feed || "", receipt: ads.receipt || "" }, enabled });
      if (enabled) injectScript(ads.client);
    }).catch(() => {});
  }, []);
  return <AdsContext.Provider value={cfg}>{children}</AdsContext.Provider>;
}
